import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { suretyKeys, companyKeys } from "@/lib/query-keys";

/** Suma RUCs a la cartera. Devuelve cuántos encontró y los que no conocemos. */
export function useAddSuretyClients() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (rucs: string[]) => {
      const res = await fetchToBackend<{ data: { found: number; notFound: string[] } }>(
        "/surety/clients",
        { method: "POST", body: JSON.stringify({ rucs }) },
      );
      return res.data;
    },
    // Cambia quién es cliente: el panel, el mercado y "seguir empresa" lo leen.
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: suretyKeys.all });
      qc.invalidateQueries({ queryKey: companyKeys.followed() });
    },
  });
}

/** Saca una empresa de la cartera de toda la organización. */
export function useRemoveSuretyClient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (companyId: number) =>
      fetchToBackend(`/surety/clients/${companyId}`, { method: "DELETE" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: suretyKeys.all });
      qc.invalidateQueries({ queryKey: companyKeys.followed() });
    },
  });
}
